import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jdgzizxyvdqnicudvwbk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpkZ3ppenh5dmRxbmljdWR2d2JrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA5MDcyOTYsImV4cCI6MjA5NjQ4MzI5Nn0.W4S_Y2s4UcBjwIZKDKsqLKrQjYL3xaE3FOaA95z3P4s'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})